import axios from 'axios';

import { Tariff } from '@/types/tariff';

/**
 * Получает список тарифов
 */
export async function getTariffs(
	params: { lang?: string } = {},
	filter: boolean = false,
): Promise<Tariff.TariffsInfoResponse> {
	const { data } = await axios.get<Tariff.TariffsInfoResponse>(
		`${process.env.HOST}/api_v1/tariff/`,
		{
			params,
		},
	);

	if (!filter) {
		return data;
	}

	return { ...data, tariffs: data.tariffs.filter((t) => t.id !== Tariff.TariffId.GoldPromo) };
}
